<template>
    <div class="orderConfirmation text-center">
        <div class="row printrow text-right"> <img style="width:100px;" class="text-left" src="/images/Essilor_RGB_Blue.jpg"> </div>
        <div class="row printrow text-left">
            <h1 class="title">Your order has been submitted</h1>
            <h3 class="subtitle tight-font">Your Essilor Preferred Rewards product order is on its way, and we are very excited to have you try our industry-leading products!
                <span v-if="frameToCome"><br>But first, you need to send us your frames. <br>Can't print right now? Don't worry we've emailed you a link to this page.</span>
            </h3>
            <div v-if="uncut">
                <h3 class=" subtitle tight-font">
                    <strong>You've ordered uncut lenses. The lenses will be sent to you ready for edging and mounting in your frame.</strong>
                </h3>
                <h3 class="subtitle tight-font">
                    <strong>If you believe this is an error, please let us know by phone at {{label.to.phone}}</strong>
                </h3>
            </div>
            <div v-if="labSupplied"></div>
        </div>
        <div class="row labelrow" style="margin-bottom:30px;" v-if="frameToCome">
            <div class="columns small-6 medium-3 lp"> <img src="/images/printlabel_new.png"> </div>
            <div class="columns small-6 medium-3 lp"> <img src="/images/wrapframe_new.png"> </div>
            <div class="columns small-6 medium-3 lp"> <img src="/images/packframe_new.png"> </div>
            <div class="columns small-6 medium-3 lp"> <img src="/images/shipframe_new.png"> </div>
        </div>
        <div style="margin-bottom:75px;" v-if="uncut">

        </div>
        <div class="orderlabel row printrow">
            <div class="columns small-12">
                <!--Shipping header -->
                <div class="ordersummary-header row   text-left">
                    <div class="columns small-12">
                        <span class="orderheader">Your Shipping Info</span>
                    </div>
                </div>
                <div class="row  text-left">
                    <div class="columns small-12 medium-7">
                        <p class="tight-font"> {{ label.from.name}} <br> {{ label.from.addressLine1}} <br v-if="label.from.addressLine2"> {{ label.from.addressLine2}} <br> {{ label.from.city}}, {{ label.from.region}} {{ label.from.postalCode}} </p>
                        <p class="tight-font"> {{ label.from.phone }} <br>{{label.from.email}} </p>
                    </div>
                    <div class="columns small-12 medium-5 end text-left">
                        <p class="tight-font">Order confirmation number:</p>
                        <p class="hero">{{label.confirmationNumber}}</p>
                        <p>
                            <vue-barcode :value="label.confirmationNumber" :options="{ format: 'CODE39', width: 1.5, height: 60, displayValue: false }"> </vue-barcode>
                        </p>
                    </div>
                </div>
                <!-- RX-->
                <div class="ordersummary-header row  text-left">
                    <div class="columns small-12">
                        <span class="orderheader">Your Order</span>
                    </div>
                </div>
                <div class="row  text-left">
                    <div class="columns small-6 medium-2">
                        <div class="tight-font"> Name:</div>
                    </div>
                    <div class="columns small-6 medium-5 end">
                        <p class="tight-font"> {{label.rxFirstName}} {{label.rxLastName}}</p>
                    </div>
                </div>
                <div class="row  text-left" v-if="choiceList">
                    <div class="columns small-6 medium-2">
                        <div class="tight-font"> Lenses:</div>
                    </div>
                    <div class="columns small-6 medium-10 end">
                        <p class="tight-font">{{choiceList}}</p>
                    </div>
                </div>
                <div class="row  text-left">
                    <div class="columns small-6 medium-2">
                        <div class="tight-font"> Frame:</div>
                    </div>
                    <div class="columns small-6 medium-9 end">
                        <p class="tight-font"> {{label.frame.manufacturer}} - {{label.frame.model}} ({{label.frame.color}})</p>
                    </div>
                </div>
                <div class="row  text-left">
                    <div class="columns small-6 medium-2">
                        <div class="tight-font"> Measures:</div>
                    </div>
                    <div class="columns small-12 medium-10 end">
                        <div class="row  text-left">
                            <div class="columns small-6 medium-3">
                                <p class="tight-font"> A Box: {{label.frame.aBox}} </p>
                            </div>
                            <div class="columns small-6 medium-3 ">
                                <p class="tight-font"> B Box: {{label.frame.bBox}}</p>
                            </div>
                            <div class="columns small-6 medium-3">
                                <p class="tight-font"> Temple: {{label.frame.templeLength}}</p>
                            </div>
                            <div class="columns small-6 medium-3 end">
                                <p class="tight-font"> DBL: {{label.frame.dbl}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="content" v-html="confirmationContent"></div> <br> -->
            </div>
        </div>
        <div class="row printrow text-left extrapad">
            <div class="columns small-12 medium-6 lp">
                <p class="tight-font">To check job status, go to <br/>https://rewards.productorder.<br/>essilorusa.com/status</p><br/>
                <p>Support Email Address: Support@essilorsupport.com</p>
            </div>
            <div class="columns small-12 medium-6 lp">
                <div v-if="frameToCome" class="row text-right">
                  <p class="tight-font text-left">
                    ATTN: Essilor Preferred Rewards Product<br>
                    {{label.to.addressLine2}}<br v-if="label.to.addressLine2">
                    {{label.to.city}}, {{label.to.region}} {{label.to.postalCode}}<br>
                    {{label.to.phone}}
                  </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueBarcode from "@xkeshi/vue-barcode";
//import CouponInput  from '@/components/CouponInput'
export default {
  props: ["label", "confirmationContent"],
  components: { VueBarcode },
  computed: {
    frameToCome() {
      return this.label.orderType === "FTC" && (this.label.jobType !== "REP");
    },
    uncut() {
      return this.label.orderType === "UNC";
    },
    labSupplied() {
      return this.label.orderType === "TBP";
    },
    choiceList() {
      var items = [];
      if (this.label.design) items.push(this.label.design);
      if (this.label.material) items.push(this.label.material);
      if (this.label.treatment) items.push(this.label.treatment);
      if (this.label.photochromic) items.push(this.label.photochromic);

      return items.join(", ");
    }
  }
};
</script>
<style>
.orderheader {
  font-size: 15pt;
  font-weight: bold;
}

.orderlabel {
  border: solid 2px;
  margin: 2px auto;
}

.printrow {
  max-width: 511pt;
}

.labelrow {
  max-width: 500pt;
}

.title {
  font-weight: 700;
  font-size: 20pt;
  margin-bottom: 15px;
}

.tight-font {
  font-size: 12pt;
  line-height: 1.2em;
}

.subtitle {
  padding-bottom: 20px;
}

.extrapad {
  padding: 15px 0;
}

.ordersummary-header {
  background-color: #00f;
  color: #fff;
  margin-bottom: 10px;
}

@media print {
  .ordersummary-header {
    background-color: #00f !important;
    -webkit-print-color-adjust: exact;
  }
}

@media print {
  .orderheader {
    color: white !important;
  }
}

.return-label-address {
  line-height: 1.1em;
  font-weight: normal;
  font-style: normal;
  font-size: 9pt;
  margin-top: 5px;
  margin-bottom: 5px;
}

.ship-to-address {
  line-height: 1.2em;
  font-weight: bold;
  font-style: normal;
  font-size: 9pt;
  text-align: left;
}

.hero {
  font-size: 35pt;
  font-weight: bold;
}
</style>